import { useEffect } from 'react';
import { useLocation, useMatches } from 'react-router';

import {
    navigationRouteIds,
    warmRouteData,
} from '~/modules/root/util/warm-route-data';

/** Lets rapid staging churn settle before spending a request on a warm. */
const WARM_DELAY_MS = 300;

/**
 * Warms the route data for `page` (see warmRouteData) while it stands staged,
 * so a subsequent Apply serves from cache.
 *
 * The `_routes` list mirrors this app's revalidation policy: a search-only
 * change refetches the leaf alone; a pathname change (a staged category
 * commit) refetches what navigationRouteIds lists.
 */
export const StagedDestinationWarmer = ({ page }: { page: string }) => {
    const location = useLocation();
    const matches = useMatches();
    const revalidatingRouteIds =
        new URL(page, 'https://x').pathname === location.pathname
            ? (matches[matches.length - 1]?.id ?? '')
            : navigationRouteIds(matches, location, page);

    useEffect(() => {
        if (!revalidatingRouteIds) return;

        const timeout = setTimeout(() => {
            warmRouteData(page, revalidatingRouteIds);
        }, WARM_DELAY_MS);
        return () => clearTimeout(timeout);
    }, [page, revalidatingRouteIds]);

    return null;
};
